/* GENERADO — no editar a mano.
 *
 * Derivado de flow/src/components/shared/primitives/Button/Button.tsx quitandole los tipos, para
 * que la previsualizacion del back office editorial monte los MISMOS
 * componentes que renderiza /historias/[slug] en el sitio publico.
 *
 * Se regenera con:                 npm run historia:sync
 * Se verifica (falla si difiere):   npm run historia:diff
 *
 * Un cambio en el componente de flow se trae con `historia:sync`. Editar este
 * archivo directamente lo pierde en la siguiente regeneracion — y peor: hace
 * que la previsualizacion muestre algo distinto de lo que se publica, que es
 * justo lo que esa pantalla existe para evitar.
 *
 * La salida definitiva es publicar estos componentes en el Design System y que
 * los dos repos los consuman; ver
 * docs/superpowers/specs/2026-08-26-editorial-design-system-design.md §5.
 */
import React from 'react';
import { Icon } from './Icon';
/* Implementación del componente C01 · Botones. Es el único botón del sistema:
   cambiar aquí el alto, el radio o el token teal propaga a todos los consumidores.
   Jerarquía BrandBook: primary (único CTA teal) · outline · ghost. Variantes
   dark (sólido negro) y danger (rojo, acciones destructivas) para producto/app.
   icon/iconRight estampan un glyph del set C05 heredando el color del texto. */
export const Button = ({
  variant = 'primary',
  size = 'md',
  onDark = false,
  fullWidth = false,
  disabled = false,
  icon,
  iconRight,
  type = 'button',
  onClick,
  style,
  children
}) => {
  const sm = size === 'sm';
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    height: sm ? 32 : 40,
    padding: sm ? '0 14px' : '0 20px',
    borderRadius: sm ? 7 : 8,
    font: `600 ${sm ? 12 : 14}px/1 var(--font-sans)`,
    cursor: disabled ? 'default' : 'pointer',
    opacity: disabled ? 0.4 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    width: fullWidth ? '100%' : undefined,
    transition: 'opacity .15s ease, background .15s ease',
    boxSizing: 'border-box',
    border: 'none'
  };
  let skin;
  if (variant === 'primary') {
    // Único tratamiento teal del sistema.
    skin = {
      background: 'var(--yool-cta)',
      color: '#fff'
    };
  } else if (variant === 'dark') {
    skin = {
      background: 'var(--yool-black)',
      color: '#fff'
    };
  } else if (variant === 'danger') {
    skin = {
      background: 'var(--yool-error)',
      color: '#fff'
    };
  } else if (variant === 'outline') {
    skin = onDark ? {
      background: 'transparent',
      border: '1.5px solid rgba(255,255,255,.35)',
      color: 'rgba(255,255,255,.85)'
    } : {
      background: 'transparent',
      border: '1.5px solid var(--yool-cta)',
      color: 'var(--yool-cta)'
    };
  } else {
    // ghost / terciario
    skin = onDark ? {
      background: 'rgba(255,255,255,.08)',
      color: 'rgba(255,255,255,.6)'
    } : {
      background: 'var(--yool-gray)',
      color: 'var(--yool-gray1)'
    };
  }
  const glyph = sm ? 15 : 16;
  return <button type={type} onClick={onClick} disabled={disabled} style={{
    ...base,
    ...skin,
    ...style
  }}>
      {icon && <Icon name={icon} size={glyph} strokeWidth={1.75} />}
      {children}
      {iconRight && <Icon name={iconRight} size={glyph} strokeWidth={1.75} />}
    </button>;
};
export default Button;
